import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { BaseModule, CmsModuleType, CmsPage, TLD } from '@packages/common';

const CONTENTFUL_DATA_SERVICE = getPublicRuntimeConfig('CONTENTFUL_DATA_SERVICE');
const FASTLANE_URL = getPublicRuntimeConfig('FASTLANE_URL');
const APP_TLD = getPublicRuntimeConfig('APP_TLD');

export async function getContentfulContent(
  asPath: string,
  query: { [key: string]: string | string[] },
  distributionFactor: number,
): Promise<CmsPage | null> {
  const [pageUrl] = asPath.split('?');
  const { preview = 'static' } = query;

  let url = `${CONTENTFUL_DATA_SERVICE}cms-content?page=${pageUrl}&abFactor=${distributionFactor}&preview=${preview}`;

  if (APP_TLD === TLD.NL) {
    url = `${FASTLANE_URL}/cms-static/web:nl?k=${pageUrl}`;
  }

  try {
    const data = await fetch(url);

    if (APP_TLD === TLD.NL) {
      //for the cms lambda response. when de and fr is also migrated to new infra, this condition can be removed
      const page = await data.json();
      return typeof page === 'string' ? JSON.parse(page) : {};
    }
    return await data.json();
  } catch (error) {
    console.error(`Could not retrieve CMS data on url ${url}`, error);
    return {} as CmsPage;
  }
}

export function findContentfulModules(config: CmsPage, moduleType: CmsModuleType): BaseModule[] {
  return Object.values(config?.modules || [])
    .flat()
    .flat()
    .filter((module) => module.contentType === moduleType);
}
